import { TextField } from '@mui/material'
import { UserProfileModel } from 'mvppoker-portal-common/api'
import React, { ChangeEvent } from 'react'
import { MVPTextInput } from '../../../TextInput/MVPTextInput'
import { FriendsFindListItem, FriendsFindListItemActions } from './FriendsFindListItem'
import './FriendsFindModal.scss'

export interface FriendsFindModalViewProps
{
	profiles: UserProfileModel[],

	clickRefresh: () => void,
	isRefreshing: boolean,
	searchCallback: (value: string) => void,
	friendsFindListItemActions: FriendsFindListItemActions,
}

export const FriendsFindModalView : React.FC<FriendsFindModalViewProps> = ({ profiles, clickRefresh, isRefreshing, searchCallback, friendsFindListItemActions }) =>
{
	const items = profiles.map((profile) => <FriendsFindListItem key={profile.userId} userProfile={profile} {...friendsFindListItemActions} />)

	return (
		<>
			<span className='modal-title-l'>FIND FRIENDS</span>
			<div className="search">
				<MVPTextInput 
					id="search-field"
					label="Search"
					onValueChanged={searchCallback}
					placeholder='Name'
				/>
			</div>
			<div id='friends-find-list'>
				{items}
			</div>
		</>
	)
}
